import {toast} from "react-toastify";
import i18n from "../i18n";
import {toastStyles} from "../TaxGuruStyles";

/**
 * Handle toast promise notifications about action.
 * @param pending pending message, optional. If empty, default value is used.
 * @param success  success message, optional. If empty, default value is used.
 * @param error error message, optional. If empty, no error toast is shown. (let axios handle it)
 * @param promiseFn
 */
export const toastPromiseWrap = <T>(
    { pending, success, error }: { pending?: string; success?: string | ((data: T) => string); error?: string },
    promiseFn: (toastId: string) => Promise<T>
): Promise<T> => {
    const toastId = crypto.randomUUID();
    toast.loading(pending ?? i18n.t("common.results.actionPendingDefault"), { toastId });
    return new Promise((resolve, reject) => {
        promiseFn(toastId)
            .then((data) => {
                toast.update(toastId, {
                    autoClose: 2000,
                    render: success ? (typeof success === "function" ? success(data) : success) : i18n.t("common.results.actionSuccessDefault"),
                    isLoading: false,
                    type: "success",
                    closeButton: true,
                    closeOnClick: true,
                    style: toastStyles.success,
                    data,
                });
                return resolve(data);
            })
            .catch((err) => {
                if (error) {
                    toast.update(toastId, {
                        autoClose: 5000,
                        render: error ?? i18n.t("common.results.actionErrorDefault"),
                        isLoading: false,
                        type: "error",
                        style: toastStyles.error,
                        closeButton: true,
                        closeOnClick: true,
                        data: err,
                    });
                }
                reject(err);
            });
    });
};
